/* global $ */
import React, { useRef, useState, useEffect, useCallback } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import Swal from 'sweetalert2';

function Renewal() {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [newRecord, setNewRecord] = useState({
        reg_form: "Fresh",
        candidate_type: "",
        certificate_type: "",
        training_atten_date: "",
        training_date: new Date(),
        batch_no: "",
        previous_batch_no: "",
        training_title: "",
        sr_no: "",
        previous_sr_no: "",
        organization: "",
        work_location: "",
        incharge: "",
        sub_contractor: "",
        evaluation_option: "",
        payment_made_by: "",
        contract_number: "",
        passport_size: "",
        stamp_size: "",
        Name: "",
        designation: "",
        contact_no: "",
        qualification: "",
        date_of_birth: "",
        languages_known: "",
        total_year_exp: "",
        current_employer: "",
        LMV_HMV_license_no: "",
        types_of_cranes_handled: "",
        marital_status: "",
        fees_amount: "",
        present_address: "",
        permanent_address: "",
        pre_evaluation_test: "",
        service_tax: "",
        license_valid_from: "",
        license_valid_to: "",
        amount_status: "",
        checked_by: "",
        verify_by: "",
    });
    const [batchNumbers, setBatchNumbers] = useState([]);
    const [trainingTitle, setTrainingTitle] = useState([]);
    const [organization, setOrganization] = useState([]);
    const [workLocation, setworkLocation] = useState([]);
    const [licenseType, setlicenseType] = useState([]);
    const [isAddressSame, setIsAddressSame] = useState(false);
    const [trainerName, settrainerName] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const fileInputRef = useRef(null);


    useEffect(() => {
        if (newRecord.present_address && newRecord.permanent_address) {
            setIsAddressSame(newRecord.present_address === newRecord.permanent_address);
        }
    }, [newRecord.present_address, newRecord.permanent_address]);

    useEffect(() => {
        const handleModalClose = () => {
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();

            $('body').css({
                'padding-right': '',
                'overflow': ''
            });

            $('.content-wrapper').css('min-height', 'calc(100vh - 114px)');
        };

        $('#editRowModal').on('hidden.bs.modal', handleModalClose);
        return () => $('#editRowModal').off('hidden.bs.modal', handleModalClose);
    }, []);


    useEffect(() => {
        const fetchBatchNumbers = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/batchno_tab');

                // Extract unique batch numbers and normalize them
                const uniqueBatchNumbers = [...new Set(
                    response.data.map(item =>
                        item.batch_no ? item.batch_no.toString().trim().replace(/\s+/g, ' ') : ""
                    )
                )].filter(batch => batch !== ""); // Filter out empty values
                setBatchNumbers(uniqueBatchNumbers);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchBatchNumbers();
    }, []);

    useEffect(() => {
        const fetchTrainingTitle = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/training_titles');
                // Use a Map to ensure unique training titles while keeping the original object structure
                const uniqueTrainingTitle = Array.from(
                    new Map(response.data.map(item => {
                        // Create a new object with normalized training_title
                        const normalizedItem = {
                            ...item,
                            training_title: item.training_title.trim().replace(/\s+/g, ' ')
                        };
                        return [normalizedItem.training_title, normalizedItem];
                    })).values()
                );
                setTrainingTitle(uniqueTrainingTitle);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchTrainingTitle();
    }, []);

    useEffect(() => {
        const fetchOrganization = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/organization_details');
                // Normalize organization names and ensure uniqueness
                const uniqueOrganization = Array.from(
                    new Map(response.data.map(item => {
                        // Create a new object with normalized organ_name
                        const normalizedItem = {
                            ...item,
                            organ_name: item.organ_name ? item.organ_name.trim().replace(/\s+/g, ' ') : ""
                        };
                        return [normalizedItem.organ_name.toLowerCase(), normalizedItem];
                    })).values()
                ).filter(org => org.organ_name !== ""); // Filter out empty values
                console.log("Normalized organizations:", uniqueOrganization);
                setOrganization(uniqueOrganization);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchOrganization();
    }, []);

    useEffect(() => {
        const fetchworkLocation = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/work_location');
                // Normalize work location names and ensure uniqueness
                const uniqueworkLocation = Array.from(
                    new Map(response.data.map(item => {
                        // Create a new object with normalized loc_name
                        const normalizedItem = {
                            ...item,
                            loc_name: item.loc_name ? item.loc_name.trim().replace(/\s+/g, ' ') : ""
                        };
                        return [normalizedItem.loc_name, normalizedItem];
                    })).values()
                ).filter(loc => loc.loc_name !== ""); // Filter out empty values
                setworkLocation(uniqueworkLocation);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchworkLocation();
    }, []);

    useEffect(() => {
        const fetchlicenseType = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/driving_license_type');
                // Normalize license types and ensure uniqueness
                const uniquelicenseType = Array.from(
                    new Map(response.data.map(item => {
                        // Create a new object with normalized driving_li_type
                        const normalizedItem = {
                            ...item,
                            driving_li_type: item.driving_li_type ? item.driving_li_type.trim().replace(/\s+/g, ' ') : ""
                        };
                        return [normalizedItem.driving_li_type, normalizedItem];
                    })).values()
                ).filter(lic => lic.driving_li_type !== ""); // Filter out empty values
                setlicenseType(uniquelicenseType);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchlicenseType();
    }, []);

    useEffect(() => {
        const fetchtrainerName = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/trainer_name_tab');
                // Normalize trainer names and ensure uniqueness
                const uniquetrainerName = Array.from(
                    new Map(response.data.map(item => {
                        // Create a new object with normalized trainer_name
                        const normalizedItem = {
                            ...item,
                            trainer_name: item.trainer_name ? item.trainer_name.trim().replace(/\s+/g, ' ') : ""
                        };
                        return [normalizedItem.trainer_name, normalizedItem];
                    })).values()
                ).filter(trainer => trainer.trainer_name !== ""); // Filter out empty values
                settrainerName(uniquetrainerName);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchtrainerName();
    }, []);


    const handleClear = () => {
        setData([]);
        setStartDate('');
        setEndDate('');
    };

    // Handle file input change
    const handleFileChange = (event) => {
        console.log(event.target.files[0]);
        console.log(event.target.name);
        const fieldName = event.target.name
        const file = event.target.files[0];
        if (file) {
            const fileURL = URL.createObjectURL(file); // Generate a temporary URL for the file

            setNewRecord((prevRecord) => {
                const updatedRecord = { ...prevRecord, [fieldName]: fileURL }; // Update only the specific field
                console.log("Updated Record with Image URL:", updatedRecord); // For debugging
                return updatedRecord;
            });
            fileInputRef.current.value = null;
        }

    };

    const handleSearch = async (e) => {
        e.preventDefault();

        if (!startDate || !endDate) {
            Swal.fire('Error!', 'Please select the date range to search bills', 'error');
            return;
        }

        setIsLoading(true); // Start loading
        try {
            const response = await axios.get(`https://api.eazyworldehsengineering.com/api/candidate_registration/expired`, {
                params: {
                    from_date: startDate,
                    to_date: endDate
                }
            });

            setData(response.data);
        } catch (error) {
            console.error('Error fetching vehicle registration number data', error);
            const errorMessage = error.response?.data?.error || error.response?.data?.message || error.response?.statusText || 'An unknown error occurred';
            Swal.fire('Error!', `There was an issue in searching the registration records: ${errorMessage}`, 'error');
        } finally {
            setIsLoading(false); // Stop loading
        }
    };


    function normalizeString(str, removeAllSpaces = false) {
        let normalized = str
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "") // Remove accents
            .replace(/[\u200B-\u200D\uFEFF]/g, '') // Remove zero-width
            .replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, '') // Remove punctuation
            .toLowerCase()
            .trim();

        if (removeAllSpaces) {
            normalized = normalized.replace(/\s+/g, ''); // Remove all spaces for comparison
        }

        return normalized;
    }


    const handleInputChange = (e) => {
        const { id, value } = e.target;

        // Create a new object to update the state correctly
        const updatedRecord = { ...newRecord, [id]: value };

        // If present_address is changed and isAddressSame is true, update both addresses
        if (isAddressSame && id === "present_address") {
            updatedRecord.permanent_address = value;
        }

        // Selecting a work location fills in the incharge mapped to it
        if (id === "work_location") {
            const selected = workLocation.find(loc => loc.loc_name === value);
            updatedRecord.incharge = selected?.incharge || "";
        }

        // Update the state with the new record
        setNewRecord(updatedRecord);
    };

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setIsAddressSame(isChecked);

        if (isChecked) {
            setNewRecord({ ...newRecord, permanent_address: newRecord.present_address });
        } else {
            setNewRecord({ ...newRecord, permanent_address: "" });
        }
    };

    const convertToYYYYMMDD = (dateStr) => {
        const date = new Date(dateStr);
        if (isNaN(date)) return ""; // Return empty if date is invalid
        return date.toISOString().split('T')[0]; // Convert to YYYY-MM-DD format
    };

    const isValidDate = (date) => {
        return date instanceof Date && !isNaN(date);
    };

    const printBill = async (row) => {
        setSelectedRow(row);
        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to Print this bill?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Print it!',
        });
        if (result.isConfirmed) {
            const printContents = document.getElementById("download_section").innerHTML;
            const originalContents = document.body.innerHTML;

            document.body.innerHTML = printContents;  // Replace body content with invoice
            window.print();  // Trigger the print dialog
            document.body.innerHTML = originalContents;
            window.location.reload(); // Ensure styles and scripts are reapplied
        }
    };

    const printBillWithFiles = async (row) => {
        setSelectedRow(row);

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to Print this bill?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Print it!',
        });

        if (result.isConfirmed) {
            // Store original content
            const originalContents = document.body.innerHTML;

            // Create a temporary container div
            const tempContainer = document.createElement('div');

            // Copy the download_section as is
            tempContainer.innerHTML = document.getElementById("download_section").innerHTML;

            // Create a div to hold the images
            const imagesDiv = document.createElement('div');
            imagesDiv.style.marginTop = "20px";

            // Function to convert an image URL to a base64 string
            const loadImageAsBase64 = (url) => {
                return new Promise((resolve, reject) => {
                    // Create a new image element
                    const img = new Image();
                    img.crossOrigin = "Anonymous"; // Try to handle CORS

                    img.onload = () => {
                        // Create a canvas to draw the image
                        const canvas = document.createElement('canvas');
                        canvas.width = img.width;
                        canvas.height = img.height;

                        // Draw the image on the canvas
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0);

                        // Get the base64 data
                        try {
                            const dataURL = canvas.toDataURL('image/png');
                            resolve(dataURL);
                        } catch (e) {
                            // If we can't get dataURL (e.g., CORS issues), just use the original URL
                            resolve(url);
                        }
                    };

                    img.onerror = () => {
                        console.error(`Failed to load image: ${url}`);
                        resolve(null); // Resolve with null to allow other images to continue
                    };

                    img.src = url;
                });
            };

            // Load all images, convert to base64 if possible
            const fileUrls = [
                row.files?.aadhar_file?.url,
                row.files?.rc_file?.url,
                row.files?.photowithbike_file?.url
            ].filter(url => url);

            try {
                // Show loading indicator
                Swal.fire({
                    title: 'Preparing print...',
                    text: 'Loading images, please wait...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                // Wait for all images to load
                for (let i = 0; i < fileUrls.length; i++) {
                    const fileUrl = fileUrls[i];
                    try {
                        // Try to get base64 version (helps with cross-origin issues)
                        const imgData = await loadImageAsBase64(fileUrl);

                        if (imgData) {
                            const imgElement = document.createElement('img');
                            imgElement.src = imgData;
                            imgElement.style.maxWidth = "100%";
                            imgElement.style.marginTop = "15px";
                            imgElement.style.pageBreakInside = "avoid";
                            imgElement.alt = `File ${i + 1}`;

                            imagesDiv.appendChild(imgElement);
                        }
                    } catch (err) {
                        console.error(`Error processing image ${fileUrl}:`, err);
                    }
                }

                // Append images div to the temp container
                tempContainer.appendChild(imagesDiv);

                // Close loading indicator
                Swal.close();

                // Replace body content with our prepared content
                document.body.innerHTML = tempContainer.innerHTML;

                // Add print styling
                const style = document.createElement('style');
                style.textContent = `
                    @media print {
                        img { max-width: 100%; page-break-inside: avoid; }
                        @page { margin: 1cm; }
                    }
                `;
                document.head.appendChild(style);

                // Print with a small delay to ensure rendering
                setTimeout(() => {
                    window.print();

                    // After printing, restore the original content
                    document.body.innerHTML = originalContents;
                    window.location.reload(); // Ensure styles and scripts are reapplied
                }, 300);
            } catch (error) {
                console.error("Error during print preparation:", error);
                Swal.fire('Error', 'There was an error preparing the print', 'error');
                document.body.innerHTML = originalContents;
                window.location.reload(); // Ensure styles and scripts are reapplied
            }
        }
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        if (!selectedRow) return;

    };
    const handleEdit = async (row) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to edit this record?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, edit it!',
        });


        if (result.isConfirmed) {
            setSelectedRow(row);
            const updatedRecord = {
                reg_form: row.reg_form,
                candidate_type: row.candidate_type,
                certificate_type: row.certificate_type || "",
                training_atten_date: isValidDate(new Date(row.training_atten_date)) ? convertToYYYYMMDD(row.training_atten_date) : "",
                training_date: isValidDate(new Date(row.training_date)) ? convertToYYYYMMDD(row.training_date) : "",
                //batch_no: row.batch_no.trim().replace(/\s+/g, ' '),
                previous_batch_no: row.batch_no.trim().replace(/\s+/g, ' '),
                training_title: row.training_title.trim().replace(/\s+/g, ' '),
                //sr_no: row.sr_no,
                previous_sr_no: row.sr_no,
                organization: row.organization,
                work_location: row.work_location.trim().replace(/\s+/g, ' '),
                incharge: row.incharge,
                sub_contractor: row.sub_contractor,
                evaluation_option: row.evaluation_option.trim().replace(/\s+/g, ' '),
                payment_made_by: row.payment_made_by.trim().replace(/\s+/g, ' '),
                contract_number: row.contract_number,
                passport_size: row.passport_size,
                stamp_size: row.stamp_size,
                Name: row.Name,
                designation: row.designation,
                contact_no: row.contact_no,
                qualification: row.qualification,
                date_of_birth: isValidDate(new Date(row.date_of_birth)) ? convertToYYYYMMDD(row.date_of_birth) : "",
                languages_known: row.languages_known,
                total_year_exp: row.total_year_exp,
                current_employer: row.current_employer,
                LMV_HMV_license_no: row.LMV_HMV_license_no,
                types_of_cranes_handled: row.types_of_cranes_handled.trim().replace(/\s+/g, ' '),
                marital_status: row.marital_status.trim().replace(/\s+/g, ' '),
                fees_amount: row.fees_amount,
                present_address: row.present_address,
                permanent_address: row.permanent_address,
                pre_evaluation_test: row.pre_evaluation_test,
                service_tax: row.service_tax,
                license_valid_from: isValidDate(new Date(row.license_valid_from)) ? convertToYYYYMMDD(row.license_valid_from) : "",
                license_valid_to: isValidDate(new Date(row.license_valid_to)) ? convertToYYYYMMDD(row.license_valid_to) : "",
                amount_status: row.amount_status,
                checked_by: row.checked_by.trim().replace(/\s+/g, ' '),
                verify_by: row.verify_by.trim().replace(/\s+/g, ' '),
            };

            // Set the state
            setNewRecord(updatedRecord);

            // Use the callback form of setState to ensure we have the latest state
            setTimeout(() => {
                //console.log("newRecord after update:", updatedRecord);
                $('#editRowModal').modal('show');
            }, 100); // Small delay to ensure state is updated
        }
    };



    const handleView = async (row) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to view this record?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, view it!',
        });


        if (result.isConfirmed) {
            setSelectedRow(row);
            setNewRecord({
                reg_form: row.reg_form,
                candidate_type: row.candidate_type,
                certificate_type: row.certificate_type || "",
                training_atten_date: isValidDate(new Date(row.training_atten_date)) ? convertToYYYYMMDD(row.training_atten_date) : "",
                training_date: isValidDate(new Date(row.training_date)) ? convertToYYYYMMDD(row.training_date) : "",
                batch_no: row.batch_no,
                training_title: row.training_title,
                sr_no: row.sr_no,
                organization: row.organization,
                work_location: row.work_location,
                incharge: row.incharge,
                sub_contractor: row.sub_contractor,
                evaluation_option: row.evaluation_option,
                payment_made_by: row.payment_made_by,
                contract_number: row.contract_number,
                passport_size: row.passport_size,
                stamp_size: row.stamp_size,
                Name: row.Name,
                designation: row.designation,
                contact_no: row.contact_no,
                qualification: row.qualification,
                date_of_birth: isValidDate(new Date(row.date_of_birth)) ? convertToYYYYMMDD(row.date_of_birth) : "",
                languages_known: row.languages_known,
                total_year_exp: row.total_year_exp,
                current_employer: row.current_employer,
                LMV_HMV_license_no: row.LMV_HMV_license_no,
                types_of_cranes_handled: row.types_of_cranes_handled,
                marital_status: row.marital_status,
                fees_amount: row.fees_amount,
                present_address: row.present_address,
                permanent_address: row.permanent_address,
                pre_evaluation_test: row.pre_evaluation_test,
                service_tax: row.service_tax,
                license_valid_from: isValidDate(new Date(row.license_valid_from)) ? convertToYYYYMMDD(row.license_valid_from) : "",
                license_valid_to: isValidDate(new Date(row.license_valid_to)) ? convertToYYYYMMDD(row.license_valid_to) : "",
                amount_status: row.amount_status,
                checked_by: row.checked_by,
                verify_by: row.verify_by,
            });
            $('#viewRowModal').modal('show');
        }
    };

    // const openaadhar = (row) => {
    //     const fileUrl = row.files?.aadhar_file?.url;
    //     if (fileUrl) {
    //         window.open(fileUrl, "_blank"); // Opens the file in a new tab
    //     } else {
    //         alert("Aadhar file not available.");
    //     }
    // };

    // const openrc = (row) => {
    //     const fileUrl = row.files?.rc_file?.url;
    //     if (fileUrl) {
    //         window.open(fileUrl, "_blank"); // Opens the file in a new tab
    //     } else {
    //         alert("RC Book file not available.");
    //     }
    // };

    // const openphoto = (row) => {
    //     const fileUrl = row.files?.photowithbike_file?.url;
    //     if (fileUrl) {
    //         window.open(fileUrl, "_blank"); // Opens the file in a new tab
    //     } else {
    //         alert("Photo not available.");
    //     }
    // };


    const filteredData = data.filter(item =>
        (String(item.batch_no).toLowerCase().includes(searchText.toLowerCase())) ||
        item.sr_no.toLowerCase().includes(searchText.toLowerCase()) ||
        item.training_date.toLowerCase().includes(searchText.toLowerCase()) ||
        item.reg_form.toLowerCase().includes(searchText.toLowerCase()) ||
        item.Name.toLowerCase().includes(searchText.toLowerCase()) ||
        item.training_title.toLowerCase().includes(searchText.toLowerCase())
    );



    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>No</span>,
            selector: (row, index) => index + 1,
            sortable: true,
            width: '60px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Batch No</span>,
            selector: row => row.batch_no || "",
            sortable: true,
            width: '120px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>R.No</span>,
            selector: row => row.sr_no || "",
            sortable: true,
            width: '130px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Issue Date</span>,
            selector: row => {
                if (!row.training_date) return ""; // Handle empty dates

                const date = new Date(row.training_date);
                return date.toLocaleDateString("en-GB"); // Formats as DD/MM/YYYY
            },
            sortable: true,
            width: '130px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Name</span>,
            selector: row => row.Name || "",
            sortable: true,
            width: '250px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Training Title</span>,
            selector: row => row.training_title || "",
            sortable: true,
            width: '350px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Phone No</span>,
            selector: row => row.contact_no || "",
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Certificate Exp</span>,
            selector: row => {
                if (!row.certificate_expired) return ""; // Handle empty dates

                const date = new Date(row.certificate_expired);
                return date.toLocaleDateString("en-GB"); // Formats as DD/MM/YYYY
            },
            sortable: true,
            width: '120px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Actions</span>,
            cell: row => (
                <div>
                    <button onClick={() => handleView(row)} className="btn btn-success btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-eye"></i>
                    </button>
                    <button onClick={() => handleEdit(row)} className="btn btn-primary btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-edit"></i>
                    </button>
                </div>
            ),
            width: '250px'
        }
    ];


    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Renewal</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Renewal</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-12">
                    <div className="card card-primary card-outline">
                        <div className="card-header">
                            <h5 className="card-title"><i className="fas fa-search mr-2"></i> Filter Records</h5>
                        </div>
                        <div className="card-body">
                            <form
                                onSubmit={handleSearch}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') e.preventDefault();
                                }}
                            >
                                <div className="form-row">
                                    <div className="form-group col-md-3">
                                        <label>From Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={startDate}
                                            onChange={(e) => setStartDate(e.target.value)}
                                            disabled={isLoading}
                                        />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>To Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={endDate}
                                            onChange={(e) => setEndDate(e.target.value)}
                                            disabled={isLoading}
                                        />
                                    </div>
                                    <div className="form-group col-md-6 d-flex align-items-end justify-content-end">
                                        <button
                                            className="btn btn-primary mr-2"
                                            type="submit"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? (
                                                <>
                                                    <i className="fas fa-spinner fa-spin mr-1"></i> Searching...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-search mr-1"></i> Search
                                                </>
                                            )}
                                        </button>
                                        <button
                                            className="btn btn-secondary"
                                            type="button"
                                            onClick={handleClear}
                                            disabled={isLoading}
                                        >
                                            <i className="fas fa-eraser mr-1"></i> Clear
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>


            {data && (
                <div className="row">
                    <div className="col-12">
                        <div className="card card-info card-outline">
                            <div className="card-header">
                                <h5 className="card-title"><i className="fas fa-table mr-2"></i> Results</h5>
                            </div>
                            <div className="card-body">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        className="form-control mb-3"
                                    />
                                </div>
                                <div className="table-responsive">
                                    <DataTable
                                        columns={columns}
                                        data={filteredData}
                                        pagination
                                        paginationPerPage={100}
                                        paginationRowsPerPageOptions={[100, 200, 300, 400]}
                                        className="table table-bordered table-hover"
                                    />
                                </div>

                                {/* view data Modal */}
                                <div className="modal fade" id="viewRowModal">
                                    <div className="modal-dialog modal-xl modal-dialog-scrollable">
                                        <div className="modal-content">
                                            <div className="modal-header bg-primary">
                                                <h4 className="modal-title">View Candidate</h4>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Registration Form</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.reg_form}</span>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Candidate Type</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.candidate_type}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Certificate Type</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.certificate_type}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className="col-md-6">
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Training Atten Date</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{convertToYYYYMMDD(newRecord.training_atten_date)}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Date Of Issue</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{convertToYYYYMMDD(newRecord.training_date)}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Batch No</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.batch_no}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Title Training</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.training_title}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Roll No</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.sr_no}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Organization</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.organization}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Work Location</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.work_location}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Incharge</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.incharge}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Sub Contractor</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.sub_contractor}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Evaluation Options</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.evaluation_option}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Payment Made By</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.payment_made_by}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Contract Number</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.contract_number || ''}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Passport Size</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.passport_size}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Stamp Size</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.stamp_size}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Name</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.Name}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Designation</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.designation}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Contact No</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.contact_no}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Qualification</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.qualification}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Date of Birth</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.date_of_birth && isValidDate(new Date(newRecord.date_of_birth)) ? new Date(newRecord.date_of_birth).toLocaleDateString("en-GB") : ""}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Languages Known</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.languages_known}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="form-section">
                                                    <h4>Experience</h4>
                                                    <hr></hr>
                                                </div>


                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Total Year Experience</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.total_year_exp}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Current Employer</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.current_employer}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>LMV/HMV License No & Details</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.LMV_HMV_license_no}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Driving License Type</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.types_of_cranes_handled}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Marital Status</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.marital_status}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Pre Evaluation Test</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.pre_evaluation_test}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Present Address</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.present_address}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Permanent Address</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.permanent_address}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>	License Valid From</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.license_valid_from}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>License Valid To</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.license_valid_to}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-section">
                                                    <h4>EWE - Officials</h4>
                                                    <hr></hr>
                                                </div>

                                                <div className='row mb-3 align-items-center'>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Checked By</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.checked_by}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row align-items-center">
                                                            <div className="col-md-4">
                                                                <label>Verified By</label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <span>{newRecord.verify_by}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer border-0">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        data-dismiss="modal"
                                                    >
                                                        Close
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Renewal Modal */}
                                <div className="modal fade" id="editRowModal">
                                    <div className="modal-dialog modal-xl modal-dialog-scrollable">
                                        <div className="modal-content">
                                            <div className="modal-header bg-primary text-white">
                                                <h4 className="modal-title">Edit Candidate Registration</h4>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <form onSubmit={handleFormSubmit}>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Registration Form</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="reg_form"
                                                                value={newRecord.reg_form || ""}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="Renewal">Renewal</option>
                                                            </select>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Candidate Type</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="candidate_type"
                                                                value={newRecord.candidate_type || ""}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value=""></option>
                                                                <option value="Management">Management</option>
                                                                <option value="Plant & Machinery">Plant & Machinery</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Certificate Type</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="certificate_type"
                                                                value={newRecord.certificate_type || ""}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value=""></option>
                                                                <option value="BMRCL PM">BMRCL PM</option>
                                                                <option value="CMRL CPR">CMRL CPR</option>
                                                                <option value="CMRL MG">CMRL MG</option>
                                                                <option value="CMRL PM">CMRL PM</option>
                                                                <option value="MMRCL CPR">MMRCL CPR</option>
                                                                <option value="MMRCL PM">MMRCL PM</option>
                                                                <option value="PMCR">PMCR</option>
                                                                <option value="CMRL PM WSC">CMRL PM WSC</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className="col-md-6">
                                                            <label class="form-label text-primary fw-bold">Training Atten Date</label>
                                                            <input
                                                                id="training_atten_date"
                                                                type="date"
                                                                value={newRecord.training_atten_date || ""} // Use the state variable
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value; // Get the input value in YYYY-MM-DD
                                                                    setNewRecord(prevState => ({
                                                                        ...prevState,
                                                                        training_atten_date: dateValue // Update state directly
                                                                    }));
                                                                }}
                                                                className="form-control"
                                                            />
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Date Of Issue</label>
                                                            <input
                                                                id="training_date"
                                                                type="date"
                                                                value={newRecord.training_date || ""} // Use the state variable
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value; // Get the input value in YYYY-MM-DD
                                                                    setNewRecord(prevState => ({
                                                                        ...prevState,
                                                                        training_date: dateValue // Update state directly
                                                                    }));
                                                                }}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>
                                                    <span className="text-danger"><strong>Previous Batch No: {newRecord.previous_batch_no}</strong></span>            
                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Batch No</label>
                                                            <select
                                                                name="batch_no"
                                                                id="batch_no"
                                                                className="form-control select2"
                                                                value={newRecord.batch_no || ""}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select a batch number</option>
                                                                {batchNumbers.map(batchNo => (
                                                                    <option key={batchNo} value={batchNo}>{batchNo}</option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Title Training</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="training_title"
                                                                name="training_title"
                                                                value={newRecord.training_title || ""}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Training Title</option>
                                                                {trainingTitle.map((item) => (
                                                                    <option
                                                                        key={item.mas_id}
                                                                        value={item.training_title}
                                                                    >
                                                                        {item.training_title}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {/* For debugging */}
                                                            <small className="text-muted">
                                                                Current value: {newRecord.training_title || "none"}
                                                            </small>
                                                        </div>
                                                    </div>
                                                    <span className="text-danger"><strong>Previous Roll No: {newRecord.previous_sr_no}</strong></span> 
                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Roll No</label>
                                                            <input
                                                                id="sr_no"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.sr_no || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Organization</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="organization"
                                                                name="organization"
                                                                value={newRecord.organization || ""}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Organization</option>
                                                                {organization.map((item, index) => {
                                                                    // Add debug logging for each option
                                                                    console.log("item:", normalizeString(item.organ_name));
                                                                    console.log("NewRecord:", normalizeString(newRecord.organization));
                                                                    const normalizedItemTitle = normalizeString(item.organ_name);
                                                                    const normalizedNewRecordTitle = normalizeString(newRecord.organization);

                                                                    const isSelected = normalizedItemTitle === normalizedNewRecordTitle;
                                                                    if (isSelected) {
                                                                        console.log(`Option ${index} matches: ${item.organ_name}`);
                                                                    }

                                                                    return (
                                                                        <option
                                                                            key={item.mas_id || index}
                                                                            value={item.organ_name}
                                                                            selected={isSelected}
                                                                        >
                                                                            {item.organ_name}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>
                                                            {/* For debugging */}
                                                            <small className="text-muted">
                                                                Current value: "{newRecord.organization || "none"}"<br />
                                                                Length: {newRecord.organization ? newRecord.organization.length : 0} chars
                                                            </small>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Work Location</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="work_location"
                                                                value={newRecord.work_location || ""}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Work</option>
                                                                {workLocation.map((item) => (
                                                                    <option key={item.mas_id} value={item.loc_name}>
                                                                        {item.loc_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Incharge</label>
                                                            <input
                                                                id="incharge"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.incharge || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Sub Contractor</label>
                                                            <input
                                                                id="sub_contractor"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.sub_contractor || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Evaluation Options</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="evaluation_option"
                                                                value={newRecord.evaluation_option || ""}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="With Evaluation">With Evaluation</option>
                                                                <option value="Without Evaluation">Without Evaluation</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Payment Made By</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="payment_made_by"
                                                                value={newRecord.payment_made_by || ""}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Organization</option>
                                                                {organization.map((item) => (
                                                                    <option key={item.mas_id} value={item.organ_name}>
                                                                        {item.organ_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Contract Number</label>
                                                            <input
                                                                id="contract_number"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.contract_number || ''}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-4'>
                                                        <div className='col-md-6'>
                                                            <label className="form-label text-primary fw-bold">Passport Size Photo</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-id-card"></i></span>
                                                                </div>
                                                                <input
                                                                    ref={fileInputRef}
                                                                    name="passport_size"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    className="form-control"
                                                                    onChange={handleFileChange}
                                                                />
                                                            </div>
                                                            <small className="form-text text-muted">Upload a clear passport-size photo (jpg/png).</small>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label className="form-label text-primary fw-bold">Stamp Size Photo</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-stamp"></i></span>
                                                                </div>
                                                                <input
                                                                    name="stamp_size"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    className="form-control"
                                                                    onChange={handleFileChange}
                                                                />
                                                            </div>
                                                            <small className="form-text text-muted">Upload a clear stamp-size photo (jpg/png).</small>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className="form-label text-primary fw-bold">Name</label>
                                                            <input
                                                                id="Name"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.Name || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label className="form-label text-primary fw-bold">Designation</label>
                                                            <input
                                                                id="designation"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.designation || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className="form-label text-primary fw-bold">Contact No</label>
                                                            <input
                                                                id="contact_no"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.contact_no || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label className="form-label text-primary fw-bold">Qualification</label>
                                                            <input
                                                                id="qualification"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.qualification || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className="form-label text-primary fw-bold">Date of Birth</label>
                                                            <input
                                                                id="date_of_birth"
                                                                type="date"
                                                                value={newRecord.date_of_birth || ""} // Use the state variable
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value; // Get the input value in YYYY-MM-DD
                                                                    setNewRecord(prevState => ({
                                                                        ...prevState,
                                                                        date_of_birth: dateValue // Update state directly
                                                                    }));
                                                                }}
                                                                className="form-control"
                                                            />
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label className="form-label text-primary fw-bold">Languages Known</label>
                                                            <input
                                                                id="languages_known"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.languages_known || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>


                                                    <div class="form-section mt-4">
                                                        <h4 class="text-primary">Experience</h4>
                                                        <hr />
                                                    </div>


                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Total Year Experience</label>
                                                            <input
                                                                id="total_year_exp"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.total_year_exp || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Current Employer</label>
                                                            <input
                                                                id="current_employer"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.current_employer || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">LMV/HMV License No & Details</label>
                                                            <input
                                                                id="LMV_HMV_license_no"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.LMV_HMV_license_no || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Driving License Type</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="types_of_cranes_handled"
                                                                value={newRecord.types_of_cranes_handled || ""}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select License Type</option>
                                                                {licenseType.map((item) => (
                                                                    <option key={item.mas_id} value={item.driving_li_type}>
                                                                        {item.driving_li_type}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Marital Status</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="marital_status"
                                                                value={newRecord.marital_status || ""}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="Single">Single</option>
                                                                <option value="Married">Married</option>
                                                            </select>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Pre Evaluation Test</label>
                                                            <input
                                                                id="pre_evaluation_test"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.pre_evaluation_test || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-4">
                                                        <div className="col-md-6">
                                                            <label htmlFor="present_address" className="form-label text-primary fw-bold">Present Address</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-map-marker-alt"></i></span>
                                                                </div>
                                                                <input
                                                                    id="present_address"
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter present address"
                                                                    value={newRecord.present_address || ""}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 d-flex align-items-end">
                                                            <div className="form-check mt-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="sameAddress"
                                                                    checked={isAddressSame}
                                                                    onChange={(e) => handleCheckboxChange(e)}
                                                                />
                                                                <label className="form-check-label" htmlFor="sameAddress">
                                                                    Same as Present Address
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-4">
                                                        <div className="col-md-6">
                                                            <label htmlFor="permanent_address" className="form-label text-primary fw-bold">Permanent Address</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-home"></i></span>
                                                                </div>
                                                                <input
                                                                    id="permanent_address"
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter permanent address"
                                                                    value={newRecord.permanent_address || ""}
                                                                    onChange={handleInputChange}
                                                                    disabled={isAddressSame}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">License Valid From</label>
                                                            <input
                                                                id="license_valid_from"
                                                                type="date"
                                                                value={newRecord.license_valid_from || ""} // Use the state variable
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value; // Get the input value in YYYY-MM-DD
                                                                    setNewRecord(prevState => ({
                                                                        ...prevState,
                                                                        license_valid_from: dateValue // Update state directly
                                                                    }));
                                                                }}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">License Valid To</label>
                                                            <input
                                                                id="license_valid_to"
                                                                type="date"
                                                                value={newRecord.license_valid_to || ""} // Use the state variable
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value; // Get the input value in YYYY-MM-DD
                                                                    setNewRecord(prevState => ({
                                                                        ...prevState,
                                                                        license_valid_to: dateValue // Update state directly
                                                                    }));
                                                                }}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div class="form-section mt-4">
                                                        <h4 class="text-primary">EWE - Officials</h4>
                                                        <hr />
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Checked By</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="checked_by"
                                                                value={newRecord.checked_by || ""}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Checked By</option>
                                                                {trainerName.map((item) => (
                                                                    <option key={item.mas_id} value={item.trainer_name}>
                                                                        {item.trainer_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Verified By</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="verify_by"
                                                                value={newRecord.verify_by || ""}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Verified By</option>
                                                                {trainerName.map((item) => (
                                                                    <option key={item.mas_id} value={item.trainer_name}>
                                                                        {item.trainer_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer border-0">
                                                        <button type="submit" class="btn btn-success">
                                                            <i class="fas fa-check mr-1"></i> Save Changes
                                                        </button>
                                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                                            <i class="fas fa-times mr-1"></i> Close
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div >
            )
            }

        </div >
    )
}

export default Renewal